<template>
    <div class="video-set-wrap">
        <bread-crumb :bread-list="breadList" />
        <div class="video-set-content">
            <div class="title-wrap">
                <i class="iconfont icon-tongyongbiaotiicon"></i>
                <span class="title-text">视频集</span>
            </div>
            <div class="search-wrap">
                <div class="search-show-wrap">
                    <el-input
                        class="search-input"
                        size="small"
                        placeholder="请输入视频集名称"
                        v-model="searchbannerTitle"
                        @keyup.enter.native="searchVideoSet">
                        <i slot="suffix"
                        class="iconfont icon-search"
                        @click="searchVideoSet"></i>
                    </el-input>
                </div>
                <el-button
                    size="small"
                    @click="clickAddOrEditVideoSet('add')">新增视频集</el-button>
            </div>
            <div class="table-wrap">
                <el-table :data="dataList"
                            stripe
                            v-loading="loading"
                            style="width: 100%">
                    <el-table-column min-width="50px"
                                        label="序号">
                        <template slot-scope="scope">
                            <span>{{  scope.$index + (page.current - 1) * page.pageSize + 1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="bannerTitle"
                                        min-width="260px"
                                        label="视频集标题">
                        <template slot-scope="scope">
                            <span class="link-btn" @click="clickVideoSet(scope.row)">
                                {{ scope.row.bannerTitle }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="uploader"
                                        min-width="100px"
                                        label="上传人员">
                    </el-table-column>
                    <el-table-column min-width="150px"
                                        label="创建时间">
                        <template slot-scope="scope">
                            <span>
                                {{ scope.row.createTime|formatDate }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="url"
                                        min-width="180px"
                                        label="URL">
                    </el-table-column>

                    <el-table-column fixed="right"
                                        label="操作"
                                        width="130">
                        <template slot-scope="scope">
                            <span @click="clickAddOrEditVideoSet('edit',scope.row)"
                                    class="link-btn">编辑</span>
                            <span @click="clickDeleteVideoSet(scope.row.bannerId)"
                                    class="link-btn">删除</span>
                        </template>
                    </el-table-column>
                    <div slot="empty"
                            class="table-none">
                        <div>
                            <svg-icon icon-class="none1" />
                        </div>
                        <span>暂无数据</span>
                    </div>
                </el-table>
            </div>
            <div class="pagination-wrap">
                <el-pagination background
                                @current-change="getVideoSetList"
                                :current-page.sync="page.current"
                                :page-size="page.pageSize"
                                layout="total, prev, pager, next, jumper"
                                :total="page.total">
                </el-pagination>
            </div>
        </div>
        <message-box
            :dialog-visible="dialogVisible"
            :id="bannerId"
            warning-text="确认将本条列表删除？"
            @handleConfirm="handleConfirm"
            @handleClose="handleClose" />
        <el-dialog :title="editType=='add'?'新增视频集':'编辑视频集'"
                :visible.sync="isEditShow"
                custom-class="group-dialog"
                width="400px">
        <el-form :model="groupForm"
                    label-width="110px"
                    :rules="groupRules"
                    class="form-wrap"
                    ref="groupForm">
            <el-form-item label="视频集名称"
                            prop="bannerTitle">
                <el-input v-model.trim="groupForm.bannerTitle"
                            placeholder="请输入视频集名称"
                            :style="{width: '250px'}"
                            maxlength="50"
                            size="small"></el-input>
            </el-form-item>
            <div class="dialog-btn-wrap">
                <el-button size="small"
                            type="primary"
                            @click="saveAddVieoSet()">提 交</el-button>
                <el-button size="small"
                            type="info"
                            plain
                            @click="cancelAddVideoSet()">取 消</el-button>
            </div>
        </el-form>
    </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { postVideoList, deleteVideo, putVideoUpload, postVideoUpload } from '@/api/videoSet'
import MessageBox from '@/components/MessageBox'
export default {
    name: 'videoSet',
    data () {
        return {
            loading: false,
            dialogVisible: false,
            breadList: [{ label: '内容管理' }, { label: '视频集', path: '/content/videoSet' }],
            searchbannerTitle: '',
            bannerId: '',
            dataList: [],
            page: {
                current: 1,
                total: 1,
                pageSize: 10
            },
            editType: 'add',
            isEditShow: false,
            groupRules: {
                bannerTitle: [
                    { required: true, message: '请输入视频集名称！', trigger: 'blur' },
                    { required: true, message: '请输入视频集名称！', trigger: 'change' }
                ]
            },
            groupForm: {
                bannerTitle: ''
            },
            editGroup: {}
        }
    },
    computed: {
        ...mapGetters([
            'userInfo'
        ])
    },
    components: {
        MessageBox
    },
    filters: {
        formatDate (value) {
            if (value) {
                return value.substring(0, 16)
            } else {
                return ''
            }
        }
    },
    methods: {
        searchVideoSet () {
            this.page.current = 1
            this.getVideoSetList()
        },
        handlePageChange (val) {
            this.getVideoSetList(val)
        },
        async getVideoSetList () {
            let params = {
                current: this.page.current,
                size: this.page.pageSize,
                bannerTitle: this.searchbannerTitle
            }
            this.loading = true
            this.dataList = []
            const { results, total } = await postVideoList(params)
            if (results.length > 0) {
                this.page.total = total
                this.dataList = results
            } else {
                if (this.page.current > 1) {
                    this.page.current -= 1
                    this.queryList()
                }
            }
            this.loading = false
        },
        saveAddVieoSet () {
            this.$refs['groupForm'].validate((valid) => {
                if (valid) {
                    this.addVideoSetFun()
                } else {
                    return false
                }
            })
        },
        async addVideoSetFun () {
            if (this.editType === 'edit') {
                const param = {
                    bannerTitle: this.groupForm.bannerTitle,
                    bannerId: this.editGroup.bannerId
                }
                const { results } = await putVideoUpload(param)
                if (results === 'failed') {
                    this.$message.error('修改失败')
                } else if (results === 'Banner name cannot be repeated') {
                    this.$message({
                        message: 'Banner名称重复，请重新填写！',
                        type: 'warning'
                    })
                } else {
                    this.$message.success('修改成功！')
                    this.isEditShow = false
                    this.page.current = 1
                    this.getVideoSetList()
                }
            } else {
                const param = {
                    bannerTitle: this.groupForm.bannerTitle,
                    uploader: this.userInfo.accountName
                }
                const { results } = await postVideoUpload(param)
                if (results === 'Banner name cannot be repeated') {
                    this.$message({
                        message: 'Banner名称重复，请重新填写！',
                        type: 'warning'
                    })
                } else {
                    this.$message.success('新增成功！')
                    this.isEditShow = false
                    this.page.current = 1
                    this.getVideoSetList()
                }
            }
        },
        cancelAddVideoSet () {
            this.groupForm.bannerTitle = ''
            this.$nextTick(() => {
                this.$refs['groupForm'].clearValidate()
            })
            this.isEditShow = false
        },
        clickAddOrEditVideoSet (type, item) {
            this.editType = type
            if (this.groupForm.bannerTitle) {
                this.groupForm.bannerTitle = ''
                this.$nextTick(() => {
                    this.$refs['groupForm'].clearValidate()
                })
            }
            if (type === 'edit') {
                this.editGroup = item
                this.groupForm.bannerTitle = item.bannerTitle
            }
            this.isEditShow = true
        },
        clickDeleteVideoSet (id) {
            this.dialogVisible = true
            this.bannerId = id
        },
        async handleConfirm () {
            this.dialogVisible = false
            this.loading = true
            const { state } = await deleteVideo(this.bannerId)
            if (state === 200) {
                this.$message({
                    message: '删除视频集成功',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '1000'
                })
                this.getVideoSetList(this.page.current)
            }
        },
        handleClose () {
            this.dialogVisible = false
            this.bannerId = ''
        },
        clickVideoSet (row) {
            this.$router.push({ path: '/content/videoSet/edit', query: { collectId: row.bannerId, collectTitle: row.bannerTitle } })
        }
    },
    created () {
        this.getVideoSetList()
    }
}
</script>

<style lang="scss">
.video-set-wrap {
    height: 100%;
    .video-set-content {
        height: calc(100% - 91px);
        box-shadow: 0 1px 4px 0 rgba(202, 202, 202, 0.5);
        margin: 20px;
        padding: 20px 20px 0 20px;
        background: #fff;
        overflow: auto;
        .title-wrap {
            font-size: 0;
            height: 16px;
            line-height: 16px;
            padding-bottom: 20px;
            .icon-tongyongbiaotiicon {
                color: $color-primary;
                font-size: 16px;
                vertical-align: middle;
            }
            .title-text {
                font-size: 14px;
                color: #333333;
                margin-left: 10px;
                display: inline-block;
                height: 16px;
                line-height: 16px;
                vertical-align: middle;
            }
        }

        .search-wrap {
            display: flex;
            justify-content: space-between;
            .search-show-wrap {
                display: flex;
            }
        }

        .table-wrap {
            margin-top: 20px;
            .table-none {
                height: 400px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                .icon {
                    font-size: 100px;
                }
                span {
                    line-height: 14px;
                }
            }
            .link-btn {
                color: $a-link;
                cursor: pointer;
                font-size: 12px;
                display: inline-block;
                height: 14px;
                line-height: 14px;
                border-right: 1px solid $a-link;
                margin-right: 6px;
                padding-right: 6px;
                &:last-child {
                    border-right: none;
                    margin-right: 0;
                    padding-right: 0;
                }
            }
        }
    }
}
.group-dialog {
    .el-dialog__body {
        display: flex;
        justify-content: center;
    }
    .el-form-item {
        margin-bottom: 24px;
        &.is-error {
            margin-bottom: 30px;
        }
    }
    .form-wrap {
        display: inline-block;
    }
    .dialog-btn-wrap {
        padding: 0 20px 24px 110px;
        text-align: left;
        .el-button {
            width: 96px;
            font-size: 14px;
        }
        .el-button--info.is-plain {
            background-color: #f5f5f5;
            border-color: #dbdbdb;
            color: #666;
        }
    }
}
</style>
